<template>
  <div id='app'>
    <router-view></router-view>
    <KeyDialog v-if="showLottery" :lotteryInfo="lotteryInfo" @close="showLottery = false"/>
  </div>
</template>
<script>
// 此文件或引入文件有调用接口调用请注意合同手机端跳转判断!this._isMobile(), 跪谢
import chatRoom from "./request/chat/chatRoom";
import {apiSystem, apiBind, msgTips, toMarkLotteryKey} from "@/request/API";
import chatApi from '@/request/customer/customerRoom'
import {Decrypt} from '@/request/customer/util.js'
import KeyDialog from './views/XXHavingYou/KeyDialog.vue';
import {getLotteryKeyPop} from "./request/API";

export default {
  name: '',
  props: {},
  components: {KeyDialog},
  data() {
    return {
      //白名单
      whiteList: ['/chatIndex', '/chatRoom', '/sellerContract', '/buyerContract', '/indemnity', '/questionnaire', '/winnersList', '/submitSuccess', '/checkRecords', '/bdSs', '/sellerInformation', '/submitOutcome', '/burerSubmitOutcome', '/certContractSign', '/buyerInformation'],
      //系统信息
      systemInfo: {
        mobile_url: process.env.VUE_APP_H5_WEBSITE
      },
      lotteryInfo: {
        event: 'register', num: 4, category: 2, activity_id: 164
      },
      showLottery: false,
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      let touchFlag
      try {
        document.createEvent("TouchEvent"); touchFlag = true
      } catch(e) {
        touchFlag = false
      }
      return flag || touchFlag;
    },

    getRequestParams() {
      let url = location.href;
      let requestParams = {};
      if (url.indexOf("?") !== -1) {
        let str = url.substr(url.indexOf("?") + 1); //截取?后面的内容作为字符串
        let strs = str.split("&"); //将字符串内容以&分隔为一个数组
        for (let i = 0; i < strs.length; i++) {
          requestParams[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
          // 将数组元素中'='左边的内容作为对象的属性名，'='右边的内容作为对象对应属性的属性值
        }
      }
      return requestParams;
    },

    //初始化websocket
    initSocket() {
      this.$WS.on('init', (e) => {
        if (!this._isMobile()) {
          apiBind({client_id: e.client_id, client: 'front'}).then(res => {
            this.$store.commit('set_clientId', e.client_id)
          })
          getLotteryKeyPop()
        } else {
        }
      })
      this.$WS.on('unread_tips', (e) => {
        this.$store.commit("set_message", e.data.message)
      })
      this.$WS.on('get_lottery', (e) => {
        toMarkLotteryKey({
          activity_id: e.data.activity_id,
          time: e.data.time,
        })
        this.lotteryInfo = e.data
        this.showLottery = true
      })
    },
  },
  async mounted() {
    if (!this._isMobile()) {
      await apiSystem({}).then(res => {
        this.systemInfo = res.data
        this.$store.commit('set_systemInfo', res.data)
      })
    }
    let search = this.getRequestParams()
    if (this.whiteList.indexOf(location.pathname) === -1 && this._isMobile()) {
      let path = this.systemInfo.mobile_url
      let href = location.href.toLowerCase()
      // if (location.href.indexOf('buyerContract') != -1 || location.href.indexOf('sellerContract') != -1 || location.href.indexOf('indemnity') != -1 || location.href.indexOf('submitSuccess') != -1 || location.href.indexOf('cusSerEval') != -1 || location.href.indexOf('checkRecords') != -1 || location.href.indexOf('sellerInformation') != -1 || location.href.indexOf('buyerInformation') != -1 || location.href.indexOf('submitOutcome') != -1 || location.href.indexOf('burerSubmitOutcome') != -1 || location.href.indexOf('certContractSign') != -1) {
      if (href.indexOf('buyercontract') != -1 || href.indexOf('sellercontract') != -1 || href.indexOf('indemnity') != -1 || href.indexOf('submitsuccess') != -1 || href.indexOf('cussereval') != -1 || href.indexOf('checkecords') != -1 || href.indexOf('sellerinformation') != -1 || href.indexOf('buyerinformation') != -1 || href.indexOf('submitoutcome') != -1 || href.indexOf('burersubmitoutcome') != -1 || href.indexOf('certcontractsign') != -1) {
        return;
      } else {
        if (location.pathname === "/gamedetails") {
          location.replace(`${path}/pages/product/detail${location.search}`)
        } else if (location.pathname === "/selectgame") {
          location.replace(`${path}/pages/product/productList?gameId=${search.game_id}&productType=product`)
        } else if (location.pathname === "/equipmentdetails") {
          location.replace(`${path}/pages/product/detail${location.search}&type=equip`)
        } else if (location.pathname === "/about") {
          location.replace(`${path}/pages/my/tool/about${location.search}`)
        } else if (location.pathname === "/vouch" && !location.search) {
          location.replace(`${path}/pages/sell/intermediary/index`)
        } else if (location.pathname === "/vouch" && location.search) {
          location.replace(`${path}/pages/sell/intermediary/info${location.search}`)
        } else if (location.pathname === "/tradeTip") {
          location.replace(`${path}/pages/my/tool/suggestions`)
        } else if (location.pathname === "/register") {
          location.replace(`${path}/pages/login/register/index${location.search}`)
        } else if (location.pathname === "/channel") {
          location.replace(`${path}/pages/my/coupon/receive/index${location.search}`)
        } else if (location.pathname === "/xx-having-you") {
          location.replace(`${path}/pages/thx/index${location.search}`)
        } else if (location.pathname === "/personalCenter/contractCenter") {
          location.replace(`${path}/pages/my/contract/index${location.search}`)
        } else {
          location.replace(`${path}${location.search}`)
        }
      }
      // this.$router.replace('/m_index');
    } else {
      // this.$router.replace('/pc_index');
    }
  },
  watch: {
    /*    '$route.name'(val){
          if (this.$route.name === 'Home') {
          let date = new Date()
          let month = date.getMonth() + 1
          let day = date.getDate()
            if (month === 12 && day === 13) {
              this.$nextTick(() => {
                let html = document.getElementsByTagName('html')[0]
                html.className = 'filterBlack'
              })
            }
          } else{
            this.$nextTick(() => {
              let html = document.getElementsByTagName('html')[0]
              html.className = ''
            })
          }
        }*/
  },
  computed: {},
  created: function () {
    if (localStorage.getItem('loginStatus') == "true") {
      this.$store.commit('set_loginStatus', localStorage.getItem('loginStatus'))
      this.$store.commit('set_userData', JSON.parse(localStorage.getItem('userData')))
      this.$store.commit('set_token', localStorage.getItem('token'))
      this.$store.commit('set_refresh_token', localStorage.getItem('refresh_token'))
      if (!this._isMobile()) {
        // 获取站内信未读
        msgTips().then(res => {
          this.$store.commit('set_siteNoticeMsg', res.data.total)
        })
      }
    }
    this.initSocket()
    // if(location.href.indexOf('chatRoom') == -1){
    //   this.initImsSocket()
    // }
    //处理过期token
    let tokens = localStorage.getItem('chatTokens')
    if (tokens) {
      tokens = JSON.parse(tokens)
      let newTokens = []
      let nowTime = new Date().getTime()
      tokens.forEach(item => {
        let day = (nowTime - item.time) / (1000 * 60 * 60 * 24)
        if (day <= 30) {
          newTokens.push(item)
        }
      })
      localStorage.setItem('chatTokens', JSON.stringify(newTokens))
    }
  },

}
</script>
<style lang='less' scoped>
#app {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #F4F4F4;
  overflow-x: clip;
  // width: 100vw;
  // min-width: 1200px;
}

</style>
